export class MobileEmailValidator {
    static DOMAINS: string[] = [
        'rakumail.jp',
        'rakuten.jp',
        'docomo.ne.jp',
        'au.com',
        '*.biz.au.com',
        'ezweb.ne.jp',
        '*.biz.ezweb.ne.jp',
        'softbank.ne.jp',
        'c.vodafone.ne.jp',
        'd.vodafone.ne.jp',
        'h.vodafone.ne.jp',
        'k.vodafone.ne.jp',
        'n.vodafone.ne.jp',
        'q.vodafone.ne.jp',
        'r.vodafone.ne.jp',
        's.vodafone.ne.jp',
        't.vodafone.ne.jp',
        'jp-k.ne.jp',
        'jp-c.ne.jp',
        'jp-d.ne.jp',
        'jp-h.ne.jp',
        'jp-n.ne.jp',
        'jp-q.ne.jp',
        'jp-r.ne.jp',
        'jp-s.ne.jp',
        'jp-t.ne.jp',
        'disney.ne.jp',
        'sky.tkk.ne.jp',
        'sky.tkc.ne.jp',
        'i.pakeo.ne.jp',
        'ido.ne.jp',
        'tu-ka.ne.jp',
        'pdx.ne.jp',
        'di.pdx.ne.jp',
        'dj.pdx.ne.jp',
        'dk.pdx.ne.jp',
        'wm.pdx.ne.jp',
        'pipopa.ne.jp',
        'moco.ne.jp',
    ];

    static DOMAINS_RULE: RegExp[] = [
        /^.+@docomo\.ne\.jp$/i,
        /^.+@moco\.ne\.jp$/i,
        /^.+@i\.pakeo\.ne\.jp$/i,

        /^.+@ezweb\.ne\.jp$/i,
        /^.+@*\.ezweb\.ne\.jp$/i,
        /^.+@ido\.ne\.jp$/i,
        /^.+@*\.ido\.ne\.jp$/i,
        /^.+@.+\.ezweb\.ne\.jp$/i,
        /^.+@.+\.ido\.ne\.jp$/i,
        /^.+@au\.com$/i,
        /^.+@*\.au\.com$/i,
        /^.+@.+\.au\.com$/i,

        /^.+@jp-[a-z]\.ne\.jp$/i,
        /^.+@tu-ka\.ne\.jp$/i,
        /^.+@*\.tu-ka\.ne\.jp$/i,
        /^.+@sky\.tu-ka\.ne\.jp$/i,
        /^.+@*\.sky\.tu-ka\.ne\.jp$/i,
        /^.+@sky\.tk[ck]\.ne\.jp$/i,
        /^.+@[a-z]\.vodafone\.ne\.jp$/i,
        /^.+@*\.sky\.tk[ck]\.ne\.jp$/i,
        /^.+@.+\.tu-ka\.ne\.jp$/i,
        /^.+@.+\.sky\.tu-ka\.ne\.jp$/i,
        /^.+@.+\.sky\.tk[ck]\.ne\.jp$/i,
        /^.+@softbank\.ne\.jp$/i,
        /^.+@disney\.ne\.jp$/i,

        /^.+@pipopa\.ne\.jp$/i,
        /^.+@.+\.pipopa\.ne\.jp$/i,

        /^.+@pdx\.ne\.jp$/i,
        /^.+@.+\.pdx\.ne\.jp$/i,

        /^.+@rakuten\.jp$/i,
        /^.+@rakumail\.jp$/i,
    ];

    private static isDisplayMainDomains(userInput: string): boolean {
        const atPos = userInput.indexOf('@');
        return atPos < 0 || atPos === userInput.length - 1;
    }

    private static generateWithMainDomains(userInput: string): string[] {
        if (userInput.lastIndexOf('@') < 0) {
            userInput += '@';
        }

        const numberOfMainDomains = 5;

        const suggestions: string[] = [];
        let index = 0;
        while (
            suggestions.length < numberOfMainDomains &&
            index <= MobileEmailValidator.DOMAINS.length
        ) {
            const domain = MobileEmailValidator.DOMAINS[index];
            if (!MobileEmailValidator.DOMAINS[index].startsWith('*.')) {
                suggestions.push(userInput + domain);
            }
            index++;
        }
        return suggestions;
    }

    private static generateWithAllDomains(userInput: string): string[] {
        const suggestions: string[] = [];
        const atPos = userInput.indexOf('@');
        const localPart = userInput.substring(0, atPos);
        const userInputDomain = userInput.substring(atPos + 1);
        const dotPos = userInputDomain.indexOf('.');
        let userInputDomainSuffix: string;
        if (dotPos >= 0) {
            userInputDomainSuffix = userInputDomain.substring(dotPos + 1);
        }

        MobileEmailValidator.DOMAINS.forEach(function (domain) {
            if (domain.startsWith('*.')) {
                const domainSuffix = domain.substring(2);
                if (dotPos < 0) {
                    // example: userInputDomain = 'abc', domain = '*.biz.ezweb.ne.jp' => suggest: example@abc.biz.ezweb.ne.jp
                    suggestions.push(localPart + '@' + userInputDomain + '.' + domainSuffix);
                } else {
                    // example: userInputDomain = 'abc.', domain = '*.biz.ezweb.ne.jp' => suggest: example@abc.biz.ezweb.ne.jp
                    // example: userInputDomain = 'abc.ezweb', domain = '*.biz.ezweb.ne.jp' => suggest: example@abc.biz.ezweb.ne.jp
                    if (
                        userInputDomainSuffix.length === 0 ||
                        domainSuffix.startsWith(userInputDomainSuffix)
                    ) {
                        suggestions.push(
                            localPart +
                                '@' +
                                userInput.substr(atPos + 1, dotPos) +
                                '.' +
                                domainSuffix,
                        );
                    }
                }
            } else {
                // example: userInput = 'example@e', domain = 'ezweb.ne.jp' => suggest: example@ezweb.ne.jp
                suggestions.push(localPart + '@' + domain);
            }
        });
        return suggestions;
    }

    private static filter(suggestions: string[], userInput: string) {
        return suggestions.filter((item) => {
            return item.startsWith(userInput);
        });
    }

    public static generateSuggestions(userInput: string) {
        const userInputLowerCase = userInput.toLowerCase();
        if (MobileEmailValidator.isDisplayMainDomains(userInputLowerCase)) {
            return MobileEmailValidator.generateWithMainDomains(userInputLowerCase);
        } else {
            const suggestionsTmp = MobileEmailValidator.generateWithAllDomains(userInputLowerCase);
            return MobileEmailValidator.filter(suggestionsTmp, userInputLowerCase);
        }
    }

    public static mobileEmailValidation(value: string): boolean {
        return MobileEmailValidator.DOMAINS_RULE.some((item) => item.test(value));
    }
}
